exports.formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
}

exports.formatedDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
}

exports.formatTime = (datetime) => {
    if (!datetime) return '';
    const dateObj = new Date(datetime);
    if (isNaN(dateObj.getTime())) return '';

    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;

    return `${hours}:${minutes} ${ampm}`;
}

exports.formatDatetime = (datetime) => {
    if (!datetime) return '';
    const dateObj = new Date(datetime);
    if (isNaN(dateObj.getTime())) return '';

    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = dateObj.getFullYear();

    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
}


exports.CheckShowBtn = (datetime) => {
    const givenDate = new Date(datetime);
    const currentDate = new Date();

    const timeDifference = currentDate - givenDate;
    const within24Hours = timeDifference <= 24 * 60 * 60 * 1000;

    return within24Hours;
};




exports.isElectron = () => {
    return typeof window !== "undefined" && !!window.electronAPI;
};

exports.silentPrint = (htmlContent) => {
    if (this.isElectron()) {
        window.electronAPI.silentPrint(htmlContent);
    } else {
        alert("Not running inside Electron.");
    }
};
